import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OwnerStatus } from '@/features/owners/types/owners-dto';
import { OwnersUtils } from '@/features/owners/utils/ownersUtils';

type Props = { status: OwnerStatus };

const OwneOwnersStatusDetails: FC<Props> = ({ status }) => {
	const { t } = useTranslation();

	const { label, icon: Icon, iconStyles } = OwnersUtils.getStatusData(status);

	return (
		<div className='flex items-center gap-1.5'>
			{<Icon className={iconStyles} />}
			<label
				className={`${
					label !== 'Unknown'
						? 'text-popover-800'
						: 'text-status-suspended'
				}`}>
				{t(label)}
			</label>
		</div>
	);
};

export default OwneOwnersStatusDetails;
